import { connect } from 'react-redux'
import { formValueSelector, reduxForm } from 'redux-form'

import SignUpCompanyComponent from '../components/login/SignUp/SignUpCompanyComponent'
import { getValidationRules } from '../validation/validation'
import COMPANY_RULES from '../validation/validationRules/company'
import SIGN_UP_RULES from '../validation/validationRules/signUp'
import { COMPANY_SIZES, COUNTRIES, INDUSTRIES } from '../constants/companyConstants'
import { validationRules, checkForOtherFields } from './CompanyFormContainer'

const selector = formValueSelector('signUp')
const currentMapStateToProps = (state, { history }) => ({
    ...checkForOtherFields(state, selector, history),
})

export default connect(currentMapStateToProps)(reduxForm({
    form: 'signUp',
    validate: getValidationRules([
        'acceptTerms',
        'acceptSubscription',
        'captcha',
    ].concat(validationRules), Object.assign(SIGN_UP_RULES, COMPANY_RULES)),
    initialValues: {
        companySize: COMPANY_SIZES[0],
        industry: INDUSTRIES[0],
        country: COUNTRIES[0],
    },
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
})(SignUpCompanyComponent));



// WEBPACK FOOTER //
// ./src/containers/SignUpCompanyContainer.js